import FormControl from './FormControl';

// export types
export type {
  FormControlProps,
  FormControlComponent,
  FormControlAccepterProps
} from './FormControl';

// export components
export { FormControl };
export default FormControl;
